
import { SignalRReceiveEvent, SignalRSendEvent } from "../../Component/Model/Enum/SignalREvents";
import { SignalRHubs } from "../../Component/Model/Enum/SignalRHubs";
import { BaseClient } from "../BaseSignalRClient";

export class FileUploadClient extends BaseClient {
    constructor() {

        super()
    }

    joinGroup = (username: string, uploadProgress: any) => {
        this.sendPayload(SignalRSendEvent.JoinGroup, username, SignalRHubs.UploadFileHub, uploadProgress);

    }

    removeListeners = (uploadProgress: any) => {
        this.removeListener(SignalRReceiveEvent.UpdateStatus, uploadProgress);
    };

}